import ListStore from '@/store/core/ListStore';
import { action, computed } from 'mobx';
import { ReceiptDetails } from '@/store/types';
import { dateFormat, numGroup } from '@/utils/filters';

export default class TaxpayerReceiptDetailsStore extends ListStore<ReceiptDetails> {
  @computed get processedData() {
    if (!this.data) return;
    return {
      ...this.data,
      dateTime: dateFormat(this.data.dateTime.slice(0, -1), {
        format: 'YYYY.MM.DD HH:mm',
        addHours: 0,
      }),
      totalSumReceipt: numGroup(this.data.totalSumReceipt) + ' ₸',
      items: this.data.items.map(({ name, sum }) => ({
        name,
        sum: numGroup(sum) + ' ₸',
      })),
    };
  }

  @action.bound async fetch(id: number) {
    this.isFetching = true;
    try {
      // const { data } = await services.selfEmployee.getReceiptDetails(id);
      // this.data = data;
      this.data = {
        numReceipt: 828701,
        dateTime: [2023, 3, 2, 11, 5, 12, 967448000],
        taxMode: 'ESP',
        taxPayerName: 'Марат Константинопольский',
        items: [
          {
            name: 'Макет',
            sum: 1500,
          },
          {
            name: 'Верстка',
            sum: 1000,
          },
          {
            name: 'Консультация',
            sum: 2100,
          },
        ],
        totalSumReceipt: 4600,
        customer: 'ТОО Канцелярские товары',
        phone: '+7(7172)22-98-54',
        qrCode:
          'iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQAAAACFI5MzAAABhElEQVR4Xu2XTYqEMBCFS1xk6RFyk/ZiDQpeTG+SI7h0Ida8VzajTPdsnzNgQYfEL4tH6rfNfzP7+eHbbnIT2t8gxcxq963BrvIep0ZN8BvK0s6WE3ZxR0wWa3AeoW15NEOxxyWkWDvXTm1XEU+jda87euJUlDaEBlzz7jkBYYzursHyFr0CshsTJC/tcRYSaIOiSJA0zc+cJjWBzZ0jOFbz0Win15EQeAW1Cg/TZ9x5Zmt5WUncJ18zInO1pcLFNB6qNQRVeq73Up2YIMuRpyLi8EiHSsEiQTupFhE8h6FZbE3PZSh+RK+IoDhBG/2TEaMdi7aaIC6YomzZLWJlLxdKUkIRl5d/TpVcRJCnhizhR+QpBeoJhoaIkOiapxiVEaYovMIBhs9THdo0JKzE9MSWHYuWFGPfxmbFhnkaJiXOhgltqNf0FFWKScRFtKsYodg2LiFjE9MTvnG5gGCK5gT5QZuAeMyw4ZURsXKaq1QkYhT/pmJ068+1SkQ+201uQvuf5AvC2HC++yEcVgAAAABJRU5ErkJggg==',
      };
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
